import { render } from "./CreateProcess.vue?vue&type=template&id=6bb72dfa"
import script from "./CreateProcess.vue?vue&type=script&lang=js"
export * from "./CreateProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__